<template>
  <v-form ref="form" v-on:submit.prevent>
    <v-layout row>
      <v-flex>
        <v-text-field
        :label="weighing.material.name"
        :suffix="getPercentage(weight)"
        type="number"
        :class="{'warning--text': dirty }"
        v-model="weight"
        v-on:keyup="debounceSubmit"
        @change="submit"
        @input="setDirty()"
        :error-messages="fieldErrors.weight"
        />
      </v-flex>

    </v-layout>
  </v-form>
</template>

<script>
import api from '@/api/app'
import formMixin from '@/mixins/formMixin'
import mutationsMixin from '@/mixins/mutationsMixin'

export default {
  props: ['weighing'],
  mixins: [formMixin, mutationsMixin],
  data () {
    return {
      delay: 500,
      dirty: false,
      weight: this.weighing.weight,
      valid: true
    }
  },
  methods: {
    setDirty () {
      this.dirty = true
      this.fieldErrors.weight = []
    },
    onSubmit () {
      this.fieldErrors = {}
      this.dirty = false
      return api.editWeighing(this.weighing.id, { weight: this.weight || null }).then(response => {
        this.weighing.weight = response.weight
      })
    },
    onSuccess () {
      this.success('Pesada actualizada con éxito')
    },
    getPercentage (weight) {
      if (!weight) {
        return
      }

      const percentage = ((weight / this.$store.state.processTotalWeight) * 100).toFixed(2)
      return `Toneladas (${percentage}%)`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/WeighingForm.vue